export default __webpack_public_path__ + "/dist/images/user_profile-img.png";